export const COLOR_THEME_NAMES = {
    SYSTEM: 'system',
    DARK: 'dark',
    LIGHT: 'light'
} as const;

export const SYSTEM_COLOR_SCHEMES = {
    LIGHT: '(prefers-color-scheme: light)',
    DARK: '(prefers-color-scheme: dark)',
} as const;

export const COLOR_THEME_CHANGED_BY_TYPES = {
    SYSTEM: 'system',
    USER: 'user',
} as const;